import React from 'react';
import { InstagramIcon } from 'lucide-react';
export function Footer({
  onOpenImpressum
}: {
  onOpenImpressum: () => void;
}) {
  return <footer className="bg-[#1a1a2e] border-t border-white/10 pt-16 pb-8 px-6" data-id="element-225">
      <div className="max-w-7xl mx-auto flex flex-col items-center" data-id="element-226">
        <a href="#" className="text-3xl font-sitename font-semibold tracking-widest uppercase text-white mb-8" data-id="element-227">
          RAW<span className="text-brand-accent ml-1" data-id="element-228">Trips</span>
        </a>

        <nav className="flex flex-wrap justify-center gap-6 md:gap-10 mb-12" data-id="element-229">
          {['Aktuelle Reise', 'Konzept', 'Models', 'Teilnehmer', 'Galerie', 'Bewerbung'].map(item => <a key={item} href={`#${item.toLowerCase().replace(' ', '-')}`} className="text-sm text-white/60 hover:text-white transition-colors tracking-wide" data-id="element-230">
              {item}
            </a>)}
        </nav>

        <div className="mb-12" data-id="element-231">
          <a href="https://www.instagram.com/fotostudio.nbg/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-white/60 hover:text-white hover:border-white/40 transition-all duration-300" aria-label="Instagram @fotostudio.nbg" data-id="element-232">
            <InstagramIcon size={18} data-id="element-233" />
          </a>
        </div>

        <div className="w-full border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between text-xs text-white/30" data-id="element-234">
          <div className="flex flex-col gap-1" data-id="element-235">
            <p data-id="element-236">© 2026 RAW Trips — Alle Rechte vorbehalten.</p>
            <p data-id="element-237">
              Ein Projekt der{' '}
              <a href="https://studio-nbg.de" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-238">
                RAW Productions GmbH
              </a>
            </p>
          </div>
          <div className="flex gap-4 mt-4 md:mt-0" data-id="element-239">
            <button onClick={onOpenImpressum} className="hover:text-white/60 transition-colors cursor-pointer" data-id="element-240">
              Impressum
            </button>
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-241">
              Datenschutz
            </a>
            <a href="#" className="hover:text-white/60 transition-colors" data-id="element-242">
              AGB
            </a>
          </div>
        </div>
      </div>
    </footer>;
}